module.exports = "/build/images/icons-public.40f6bcd8.svg";